import Vue from 'vue'
import VueRouter from 'vue-router'
// import NQ5C from '@/views/NQ5C'
// import nq5cAW from '@/views/nq5c-AW'
// import nq5cAW2024 from '@/views/nq5c-AW2024'
import nq5cAW2025 from '@/views/nq5c-AW2025'
import terms from '@/components/aw2025/terms'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'nq5c',
  //   component: NQ5C
  // },
  // {
  //   path: '/',
  //   name: 'nq5c-aw',
  //   component: nq5cAW
  // },
  // {
  //   path: '/',
  //   name: 'nq5c-aw2024',
  //   component: nq5cAW2024
  // },
  {
    path: '/',
    name: 'nq5c-aw2025',
    component: nq5cAW2025
  },{
    path: '/terms',
    name: 'terms',
    component: terms
  }
]

const router = new VueRouter({
  routes
})

export default router
